import { useEffect, useState } from 'react';

export default function ThemeToggle() {
    const [isDark, setIsDark] = useState(false);

    // Load theme on mount
    useEffect(() => {
        // const storedTheme = localStorage.getItem('theme');
        // const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
        // const activeDark = storedTheme === 'dark' || (!storedTheme && prefersDark);
        let activeDark = true;
        const query = new URLSearchParams(window.location.search);
        if (query.has('dark') && parseInt(query.get('dark')) === 0) {
            activeDark = false;
        }

        document.body.classList.toggle('dark', activeDark);
        setIsDark(activeDark);
        moveSummary(activeDark);
    }, []);

    // Toggle and persist
    const toggleTheme = () => {
        const newDark = !isDark;
        setIsDark(newDark);
        document.body.classList.toggle('dark', newDark);
        localStorage.setItem('theme', newDark ? 'dark' : 'light');
        moveSummary(newDark);
    };

    const moveSummary = (darkMode) => {
        const summary = document.getElementById('main-summary');
        const stepsParent = document.getElementById('steps-parent');
        const mainContainer = document.getElementById('main-container');

        if (!summary || !stepsParent || !mainContainer) return;

        if (darkMode) {
            // Move next to #main-container
            mainContainer.parentNode.insertBefore(summary, mainContainer.nextSibling);
        } else {
            // Move inside #steps-container
            stepsParent.appendChild(summary);
        }
    };

    return (
        <button
            onClick={toggleTheme}
            className="hidden px-3 rounded-full bg-gray-900 dark:text-gray-100 text-gray-100 dark:text-lg shadow-md transition opacity-75"
            title="Toggle dark mode"
        >
            {isDark ? '☀' : '🌙️'}
        </button>
    );
}
